import * as React from 'react';

const IdentificationContent = () => {
    return (
        <>
            <h4>
                Identification of the HER2 gene
            </h4>
            <p>
                The HER2 (human epidermal growth factor receptor 2) gene makes HER2 proteins. HER2 proteins are receptors that are normally present in small numbers on breast cells. But in about 20% of breast cancers, the HER2 gene doesn’t work correctly and makes too many copies of itself (known as HER2 gene amplification). All these extra HER2 genes tell breast cancer cells to make too many HER2 receptors (HER2 protein overexpression). This makes breast cancer cells grow and divide in an uncontrolled way.
            </p>
        </>
    );
}

export default IdentificationContent;